import { deepKeysToCamel } from '@eb/transformation-utils';
import { formatUrl } from 'url-lib';
import { CONTINUATION_KEY } from 'eventbrite';
import { sdkRequest, dangerouslyFetchAllPages } from '@eb/http';
import { DEFAULT_EXPANDED_EVENT_PAGE_SIZE } from './constants';
import {
    transformEvents,
    transformOrganizers,
    transformStatusCounts,
} from './utils';

const _getEventsByOrganizationURL = (organizationId, params = {}) =>
    formatUrl(`/api/v3/organizations/${organizationId}/events/`, params);

const _getUpcomingEventInSeries = (seriesId) =>
    `/api/v3/series/${seriesId}/events/?time_filter=current_future&page_size=1`;

export const fetchUpcomingEvent = (seriesId) =>
    sdkRequest(_getUpcomingEventInSeries(seriesId)).then(({ events }) =>
        transformEvents(events),
    );

export const fetchEvents = (organizationId, params = {}) =>
    sdkRequest(_getEventsByOrganizationURL(organizationId, params)).then(
        ({ events, ...response }) => ({
            ...response,
            events,
            normalizedEvents: transformEvents(events),
        }),
    );

export const fetchAllEvents = (organizationId, params = {}) =>
    dangerouslyFetchAllPages(
        _getEventsByOrganizationURL(organizationId, params),
        'events',
        CONTINUATION_KEY,
    ).then(({ objects }) => transformEvents(objects));

export const fetchEventsByIds = (eventIds, params = {}) =>
    dangerouslyFetchAllPages(
        formatUrl('/api/v3/events/', {
            page_size: DEFAULT_EXPANDED_EVENT_PAGE_SIZE,
            ...params,
            event_ids: eventIds.join(','),
        }),
        'events',
        CONTINUATION_KEY,
    ).then(({ objects }) => transformEvents(objects));

const _getOrganizersByOrganizationURL = (organizationId, params = {}) =>
    formatUrl(`/api/v3/organizations/${organizationId}/organizers/`, params);

export const fetchOrganizers = (organizationId, params = {}) =>
    sdkRequest(_getOrganizersByOrganizationURL(organizationId, params)).then(
        ({ organizers, ...response }) => ({
            ...response,
            organizers,
            normalizedOrganizers: transformOrganizers(organizers),
        }),
    );

export const fetchAllOrganizers = (organizationId, params = {}) =>
    dangerouslyFetchAllPages(
        _getOrganizersByOrganizationURL(organizationId, params),
        'organizers',
    ).then(({ objects }) => transformOrganizers(objects));

const _getStatusCountsURL = (organizationId, params = {}) =>
    formatUrl(`/api/v3/organizations/${organizationId}/event_count/`, params);

const _getCheckoutSettingsURL = (organizationId) =>
    `/api/v3/organizations/${organizationId}/checkout_settings`;

export const fetchStatusCounts = (organizationId, params = {}) =>
    sdkRequest(_getStatusCountsURL(organizationId, params)).then((response) => {
        return transformStatusCounts(response);
    });

export const fetchCheckoutSettings = (organizationId) =>
    sdkRequest(_getCheckoutSettingsURL(organizationId)).then((response) =>
        deepKeysToCamel(response),
    );
